import { videoPreferenceSchema, type StudioDraft } from './studio-draft';
import { recoveryIssue, type RecoveryIssue } from './draft-recovery-description';
import { compactLandscapePreference } from '../services/compact-landscape-preference';

/** Retain supported choices while moving landscape editing to compact overlays. */
export function recoverAppearances(candidate: unknown, defaults: StudioDraft['appearances']) {
  const appearances = { ...defaults };
  const issues: RecoveryIssue[] = [];
  if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) {
    return { appearances, issues: [recoveryIssue('appearances', candidate, defaults)] };
  }
  const accepted: StudioDraft['appearances'] = {};
  for (const [identity, value] of Object.entries(candidate)) {
    const parsed = videoPreferenceSchema.safeParse(value);
    const expected = defaults[identity];
    if (parsed.success && expected && parsed.data.preset === expected.preset) {
      const value = identity === '2:landscape-16x9' ? compactLandscapePreference(parsed.data) : parsed.data;
      accepted[identity] = value;
      appearances[identity] = value;
    } else issues.push(recoveryIssue(`appearances.${identity}`, value, expected));
  }
  // Preserve supported layouts written before renderer capabilities finished loading.
  for (const [storedIdentity, value] of Object.entries(accepted)) {
    if (value.presentation.version !== 2) continue;
    const identity = `2:${value.preset}`;
    if (storedIdentity === identity) continue;
    const current = accepted[identity];
    const baseline = videoPreferenceSchema.safeParse(defaults[identity]);
    const unusedDefault = current && baseline.success && JSON.stringify(current) === JSON.stringify(baseline.data) && !current.chosen;
    if (!current || unusedDefault) appearances[identity] = value;
  }
  return { appearances, issues };
}
